import { Grid, Typography } from '@mui/material';

import MuiDialog from 'components/MuiDialog';
import { TFallDefaultValues, SurveyDialogProps } from 'routes/Main/Survey/type';

import Calculator1 from './Calculator1';
import Calculator2 from './Calculator2';
import Calculator3 from './Calculator3';
import CautionList from './CautionList';
import Counselor from './Counselor';

const DrugCalculatior = (props: SurveyDialogProps<TFallDefaultValues>) => {
  const { title, isOpen, defaultValues, onClose } = props;

  return (
    <MuiDialog.SurveyFormColumn
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          Công cụ tính toán liều\nlượng thuốc
        </Typography>
        <Calculator1 />
        <Calculator2 />
        <Calculator3 />
        <CautionList />
        <Counselor />
      </Grid>
    </MuiDialog.SurveyFormColumn>
  );
};

export default DrugCalculatior;
